import React, { useState } from 'react';
import { useMemo } from "react";
import { useWatch, useFormContext } from "react-hook-form";
import FormValues from '../../components/FormValues';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Controller } from "react-hook-form";
import 'react-phone-number-input/style.css';
import {  useForm } from 'react-hook-form';

import { toast } from "react-toastify";
import { Country } from "country-state-city";

const customStyles = {
  control: () => ({
    minWidth: '100%',
    display: 'flex',
    height: '40px',
    borderRadius: '6px',
    background: '#F8F8F8',
    borderTop: 'transparent',
    borderLeft: 'transparent',
    borderRight: 'transparent',
    fontSize: '12px',
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%)',

    //   padding: "6px 3px 3px 6px",
    color: '#BDBDBD',
    alignItems: 'left',
    justifyContent: 'left',
  }),
  option: () => ({
    cursor: 'pointer',
    fontSize: '10px',
    marginBottom: '2px',
    padding: '10px',
    color: '#BDBDBD',
    '&:hover': {
      background: '#2698C6',
      color: 'black',
    },
  }),
};

export const ContactUsForm = () => {

    const [loader, setLoader] = useState(false);
     const types = [ { code: 100000013, label: "Seeking Funding" },
  { code: 100000003, label: "Accelerators" },
  { code: 100000009, label: "Accredited" },
  { code: 100000001, label: "Angel Group" },
  { code: 100000000, label: "Angel Investor" },
  { code: 100000002, label: "Family Office" },
  { code: 100000004, label: "Funds" },
  { code: 100000010, label: "Fund Manager" },
  { code: 100000008, label: "Incubator" },
  { code: 100000006, label: "Investment Bank" },
  { code: 100000007, label: "Individual Investor OR HNWI" },
  { code: 100000011, label: "Studio" },
  { code: 100000005, label: "VC Firms" },
  { code: 100000012, label: "Other" }];

    const business_types = types.map(c => ({
      value: c.code,
      label: c.label,
    }));
    const showSuccessNotification = (message: any) => {
      toast.success(message);
      reset();
    };
    
    const showErrorNotification = (error: any) => {
      toast.error(error);
      reset();
    };
    const countries = Country.getAllCountries().map(c => ({
    value: c.isoCode,
    label: c.name,
  })); 
  const resolver = yupResolver(
     yup.object().shape({
    firstName: yup.string().required('Please enter your first name.'),
    lastName: yup.string().required('Please enter your last name.'),
    email: yup.string().required('Please Enter E-mail.'),
    company: yup.string().required('Required Field.'),
    country:  yup.string().required('Please select a country').oneOf(countries.map(c => c.value), 'Please select a valid country'),
    agree: yup.boolean().oneOf([true], 'You must agree to continue'), // ✅ require checkbox

  })
  );

  const defaultValues: any = {
    firstName: '',
  lastName: '',
  email: '',
  phone: '',
  company: '',
  country: '',
  businessType: '',
  message: '',
  agree: false,
  };

  const methods = useForm({ defaultValues, resolver });
  const {
    handleSubmit,
    register,
    control,
    watch,
    trigger, // add trigger
    formState: { errors },
    reset,
  } = methods;


  


  const agreeChecked = watch("agree", false); // false by default

  const onSubmit = (values:any) => { 
    setLoader(true);
      // Map country, state, and businessType to their labels
  const countryLabel = countries.find(c => c.value === values.country)?.label || values.country;
  

    const contacts = {
        "firstname":values.firstName,
        "lastname":values.lastName,
        "email":values.email,
        "phone":values.phone,
        "company":values.company,
        "country":countryLabel,
        "businesstype":values.businessType,
        "consent":values.agree ? 1 : 0,
        "message":values.message,
        "leadsource": 100000007 // KC Contact

    };

    try {
      fetch('https://konzortiacapital.com/save.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contacts),
    })
      .then(response => response.json())
      .then(data => {
        if (data.message == 'Data received successfully') {
          setLoader(false);

          showSuccessNotification('Successfully submitted, We will contact you soon');
        } else {
          showErrorNotification("An error Occured, Try again later!");
          setLoader(false);
        }
      }).catch((err) => {
        showErrorNotification("An error Occured, Try again later!");
        setLoader(false);
      });

    } catch (error) {
        //console.error('Error submitting form:',error);
        showErrorNotification("An error Occured, Try again later!");
        setLoader(false);
    }
  }

  //console.log(loader,'loader')
  return (
    
    <form onSubmit={handleSubmit(onSubmit)}>
    <div className='pl-2'>
      <div className='bg-gray rounded center-div py-4 max-w-[900px] mx-auto'>
  
        <>
        <span className='font-primary font-size-16 font-bold'>
          Request Information
        </span>
        <div className='w-12/12'>
          <div className='flex flex-col'>
            <div className='flex flex-row w-12/12'>
              <div className='pt-2 w-100 px-2 pb-2'>
                {' '}
                <FormValues
                  type='text'
                  name='firstName'
                  control={control}
                  errors={errors}
                  register={register}
                  placeholder='First Name'
                  className='form-control w-100 font-primary font-size-12 '
                  hidePasswordButton={true}
                />
              </div>
              <div className='pt-2 w-100 px-2 pb-2'>
                {' '}
                <FormValues
                  type='text'
                  name='lastName'
                  control={control}
                  errors={errors}
                  register={register}
                  placeholder='Last Name'
                  className='form-control w-100 font-primary font-size-12 '
                  hidePasswordButton={true}
                />
              </div>
            </div>
            <div className='flex flex-row w-12/12'>
              <div className='pt-2 w-100 px-2 pb-2'>
                {' '}
                <FormValues
                  type='text'
                  name='email'
                  control={control}
                  errors={errors}
                  register={register}
                  placeholder='Email'
                  className='form-control w-100 font-primary font-size-12 '
                  hidePasswordButton={true}
                />
              </div>
              <div className='pt-2 w-100 px-2 pb-2'>
                {' '}
                <FormValues
                  type='text'
                  name='phone'
                  control={control}
                  errors={errors}
                  register={register}
                  placeholder='Phone number'
                  className='form-control w-100 font-primary font-size-12 '
                  hidePasswordButton={true}
                />
              </div>
            </div>

            <div className='px-2 pb-2   w-12/12'>
                {' '}
                <Controller
                    name="country"
                    control={control}
                    render={({ field }) => (
                      <select
                        {...field}
                        className="form-control w-full font-primary text-xs"
                      >
                        <option value="">Select Country</option>
                        {countries.map(c => (
                          <option key={c.value} value={c.value}>
                            {c.label}
                          </option>
                        ))}
                      </select>
                    )}
                  />
                  {errors.country && (
                    <p className="text-red-500 text-xs mt-1">{errors.country.message?.toString()}</p>
                  )}
           
            </div>
            <div className=' px-2 pb-2'>
              {' '}
              <FormValues
                type='text'
                name='company'
                control={control}
                errors={errors}
                register={register}
                placeholder='Company/Firm'
                className='form-control font-primary font-size-12 '
                hidePasswordButton={true}
              />
            </div>
            <div className=' px-2 pb-2 w-12/12 '>
              {' '}
               <select
                  {...register("businessType")}
                  className="form-control w-full font-primary text-xs"
                  defaultValue=""
                >
                  <option value="" disabled>Select Type</option>
                  {business_types.map(c => (
                    <option key={c.value} value={c.value}>{c.label}</option>
                  ))}
                </select>
            </div>
            <div className=' px-2 pb-2 w-12/12 '>
              {' '}
               <textarea
                {...register("message")}
                placeholder="Your message"
                className="form-control font-primary font-size-12 w-full h-24 p-2 rounded"
              />
              
            </div>
            <div className='font-primary font-size-8 text-black px-4'>
              <input
                 {...register("agree")}
                type="checkbox"
                id="agree"
                className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label htmlFor="agree" className="ml-2 font-primary text-xs text-black">
                Agree to our privacy policy, cookie policy, and terms of use. You also agree to receive Alpha Hub’s emails and messages about our products and services.
              </label>
           </div>
            <div className='w-1212 flex right-div px-4 pt-4'>
    <button  
    className={`flex justify-center items-center px-4 py-2 rounded font-primary text-white
    ${!agreeChecked || loader ? "bg-gray-400 cursor-not-allowed" : "btn-primary text-white"}`}
    type="submit" >
        { loader ? <div className="mt-2 spinner" ></div> : <span className="mt-1">Send</span>}
    </button>
</div>
          </div>
        </div>
        </>
     
      </div>
    </div>
    </form>
  );
};
